import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { catalogBibShape, bibShape } from '@bibliocommons/bc-prop-types';
import {
  FullScreenOverlayBody,
  FullScreenOverlayHeader,
  FullScreenOverlayContent
} from 'app/components/shared/FullScreenOverlay';
import { BibBriefContainer } from 'app/components/bibs/shared/BibBrief';
import loadScript from 'load-script';

import './ExcerptOverlay.scss';

export default function ExcerptOverlay({ excerpt, catalogBib, bib, googlePreviewAvailable }) {
  const metadataId = catalogBib.get('metadataId');
  const canvas = useRef(null);

  useEffect(() => {
    if (!googlePreviewAvailable) return () => {};
    const googleBookSdkUrl = 'https://www.google.com/books/jsapi.js';
    if (!window.google) loadScript(googleBookSdkUrl, () => window.google.books.load());

    function loadBook() {
      const isbns = bib
        .getIn(['briefInfo', 'isbns'])
        .map(isbn => `ISBN:${isbn}`)
        .toJS();
      const viewer = new window.google.books.DefaultViewer(canvas.current);
      viewer.load(isbns);
    }

    // There is no working way to check if google SDK finished initializing
    // so we have to check it periodically
    const intervalId = setInterval(() => {
      if (window.google && window.google.books.DefaultViewer) {
        loadBook();
        clearInterval(intervalId);
      }
    }, 50);

    return () => clearInterval(intervalId);
  }, [bib, googlePreviewAvailable]);

  const overlaySize = googlePreviewAvailable ? 'medium' : 'small';

  return (
    <FullScreenOverlayBody className="cp-bib-excerpt-overlay">
      <FullScreenOverlayHeader title={<FormattedMessage id="read_excerpt" />} />
      <FullScreenOverlayContent size={overlaySize}>
        <BibBriefContainer metadataId={metadataId} />
        {/* eslint-disable react/no-danger */}
        {googlePreviewAvailable ? (
          <div className="google-book-preview" ref={canvas} />
        ) : (
          <span dangerouslySetInnerHTML={{ __html: excerpt }} />
        )}
      </FullScreenOverlayContent>
    </FullScreenOverlayBody>
  );
}

ExcerptOverlay.propTypes = {
  excerpt: PropTypes.string,
  catalogBib: catalogBibShape.isRequired,
  bib: bibShape.isRequired,
  googlePreviewAvailable: PropTypes.bool.isRequired
};
